import { useMemo } from "react";
import { useIntl } from "react-intl";
import commonMessages from "../../../common/messages";

const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translations = useMemo(() => {
    return {
      defaultError: formatMessage(commonMessages.defaultError),
    };
  }, [formatMessage]);

  return translations;
};

export default useTranslations;
